export default __webpack_public_path__ + "static/media/9.69bd9bcc.png";